'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _signature_pad = require('signature_pad');

var _signature_pad2 = _interopRequireDefault(_signature_pad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A plugin to handle signature pad actions like init, retry and send.
 */
var signaturePadPlugin = {

  /**
   * Init function for specific signature-pad element.
   * 
   * @param {DOM element}  padElement              The DOM element of the `.signature-pad`.
   * @param {function}     clearButtonCallback     Function which will be executed when the `Clear` 
   *                                              button is clicked.
   * @param {function}     useButtonCallback       Function which will be executed when the `Use` 
   *                                              button is clicked.
   * 
   * @return {object}      signaturePad            The instanse of SignaturePad module, that contains
   *                                              data from canvas.
   */
  init: function init(padElement, clearButtonCallback, useButtonCallback) {
    if (padElement != null) {
      // Check if touchstart is enabled (if mobile) and accordingly
      // bind the event to signpad to remove background color and text

      var canvas = padElement.querySelectorAll('.js-signature-pad__pad')[0];

      var signaturePad = new _signature_pad2.default(canvas),
          rescale = function rescale() {
        signaturePadPlugin._rescale(canvas, signaturePad);
      };

      // Avoids signature zoom on hight DPI screens.
      signaturePadPlugin._rescale(canvas, signaturePad);
      window.addEventListener('resize', rescale);
      window.addEventListener('orientationchange', rescale);

      // Binds a callback to the canvas wrapper to change
      // the background color and remove the text from signpad.
      var canvasWrappers = padElement.querySelectorAll('.js-signature-pad__canvas-wrapper');
      Array.prototype.forEach.call(canvasWrappers, function (element) {
        var thisPad = element;

        // Fix for chrome bug,  windows 10 touch surfaces
        // browser should trigger touch and mouse events.
        if ('ontouchstart' in document.documentElement) {
          thisPad.addEventListener('touchstart', function (event) {
            event.preventDefault();
            this.parentNode.classList.add('is-focused');
          }, false);
        }

        thisPad.addEventListener('mousedown', function (event) {
          event.preventDefault();
          this.parentNode.classList.add('is-focused');
        }, false);
      });

      // Binds a callback to the `Use` button.
      // This callback can be specified in the options object given at
      // the plugin init on the DOM element.
      //
      // The callback will provide both the `signaturePad` element, and the button which was clicked 
      // i.e. the `Use` button.
      padElement.querySelector('.js-signature-pad__btn-use').addEventListener('click', function (event) {
        if (useButtonCallback) {

          event.preventDefault();
          useButtonCallback(signaturePad, this);
        }
      });

      // Binds a callback to the `Clear` button.
      // This callback can be specified in the options object given at
      // the plugin init on the DOM element.
      //
      // The callback will provide both the `signaturePad` element, and the button which was clicked 
      // i.e. the `Clear` button.
      padElement.querySelector('.js-signature-pad__btn-clear').addEventListener('click', function (event) {
        signaturePad.clear();

        // Change background-color of canvas if signature-pad is made empty.
        padElement.classList.remove('is-focused');

        if (clearButtonCallback) {

          event.preventDefault();
          clearButtonCallback(signaturePad, this);
        }
      });

      return signaturePad;
    }
  },

  /**
   * Rescales the canvas for both low and hight DPI screens. This avoids a
   * zoomed image on screens like retina displays...
   * @param {object} canvas The pad canvas.
   * @param {object} signaturePad The signature pad.
   */
  _rescale: function _rescale(canvas, signaturePad) {

    var ratio = Math.max(window.devicePixelRatio || 1, 1);

    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext("2d").scale(ratio, ratio);

    signaturePad.clear(); // otherwise isEmpty() might return incorrect value
  }

};

exports.default = signaturePadPlugin;